export default {
  Repairer: 'Q',
  Pdr: 'P'
}